var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPhone = function SvgIconPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF1EB7",
    fillRule: "evenodd",
    d: "M2.725 0h9.55a2.66 2.66 0 0 1 1.91.76c.512.501.805 1.187.815 1.906v18.668c-.027 1.495-1.245 2.687-2.725 2.666h-9.55C1.245 24.02.027 22.83 0 21.334V2.666C.027 1.17 1.245-.021 2.725 0Zm2.9 3.79h3.75a.942.942 0 0 0 .938-.948.942.942 0 0 0-.938-.947h-3.75a.942.942 0 0 0-.937.947c0 .524.42.948.937.948Z",
    clipRule: "evenodd"
  })));
};
export default SvgIconPhone;